export const sessionTimeout = `
<div class="modal-header-wrapper">  
    <h3 class="lead">O tempo de sessão expirou.</h3>
    <p>Iremos refazer a busca para verificar a disponibilidade das companhias neste momento.</p>
</div>
<div class="btn-group">           
    <a href="#" title="Alterar sua busca"  id="btn-try-purchase-again" class="btn btn-success btn-large">Buscar novamente</a>
</div>`;